import React, { useEffect, useState } from 'react';
import { SFuncModal } from 'shj-components';
import { Form, Input, InputNumber, message, Select } from 'antd';
import { manualAddBlance } from '@/services/insureManagement'
import { httpDictServ } from '@/services';
import { getEnums } from '@/services/homeService';

const { Option } = Select;

export function RechargeModel({ fn, ...rest }: any) {
    const onClose = () => {
        dialog.destroy();
    };

    const dialog = SFuncModal({
        title: '手动充值',
        width: 600,
        vanish: true,
        content: <Recharge onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const Recharge = ({ onClose, fn, ...rest }: any) => {
    const TextArea = Input.TextArea;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [insurCostTypeList, setInsurCostTypeList] = useState([])
    useEffect(() => {
        getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurCostTypeEnum").then((response: any) => {
            setInsurCostTypeList(response)
        });
        if (rest && rest.id) {
            form.setFieldsValue({ ...rest });
        }
    }, []);
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            setLoading(true);
            // values.approvalStatu = rest.approvalStatu;
            values.accountId = rest.id;
            manualAddBlance(values).then((response: any) => {
                message.success('操作成功');
                fn & fn();
                onClose();
            })
                .finally(() => {
                    setLoading(false);
                });
        })

    };

    return (
        <SFuncModal.Content
            onCancel={onClose}
            onOk={onFinish}
            confirmLoading={loading}>
            <Form form={form} layout="vertical">
                <Form.Item label="门店" name="companyName">
                    <Input disabled />
                </Form.Item>
                <Form.Item label="姓名" name="employeeName">
                    <Input disabled />
                </Form.Item>
                <Form.Item label="技能标签" name="workTypeNames">
                    <Input disabled />
                </Form.Item>
                <Form.Item label="账户余额(元)" name="balance">
                    <Input disabled />
                </Form.Item>
                <Form.Item label="充值类型" name="costType" rules={[
                    { required: true, message: '请选择充值类型' }
                ]}>
                    <Select
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                    >
                        {insurCostTypeList.length && insurCostTypeList.map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.key}>
                                    {item.description}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label="金额" name="amount" rules={[
                    { required: true, message: '请输入金额' }
                ]}>
                    <InputNumber precision={2} style={{ width: '100%' }} max={999999.99} min={0.01} />
                </Form.Item>
                <Form.Item label="备注" name="remarks">
                    <TextArea rows={4} />
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    );
};
